import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/Button';
import { openDemoMail } from '../lib/mailto';
import { TOURS_HASH } from '../hooks/useHashRoute';
export function Nav() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = ['About', 'Services', 'How It Works', 'Partners', 'Demo'];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'py-4' : 'py-6'}`} data-id="element-115" data-mp="1prld74q29ony">
      <div className="max-w-7xl mx-auto px-6" data-id="element-116" data-mp="1yqglqngkvauf">
        <div className={`flex items-center justify-between rounded-full transition-all duration-500 ${isScrolled ? 'glass-panel px-6 py-3' : 'px-2 py-2'}`} data-id="element-117" data-mp="1yrrqaphukmml">
          {/* Logo */}
          <a href="#" className="flex items-center gap-2.5" data-id="element-118" data-mp="1y7i37breztwx">
            <img src="https://cdn.magicpatterns.com/uploads/nrutqAxUPjySDmYrV6bARm/munisverse.png" alt="MUNISVerse" className="w-9 h-9 rounded-full object-cover" data-id="element-119" data-mp="1u3tswlbeek7z" />
            <span className="font-display font-semibold text-xl tracking-tight" data-id="element-120" data-mp="1k778tyqwbx70">
              MUNISVerse
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-121" data-mp="2cv32svp2zb03">
            {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="text-sm font-medium text-zinc-400 hover:text-white transition-colors" data-id="element-122" data-mp="283l3sd6mbkhr">
                {link}
              </a>)}
            <a href={TOURS_HASH} className="text-sm font-medium text-white hover:text-zinc-300 transition-colors" data-id="element-123" data-mp="2vtp9cq3d9ube">
              Virtual Tours
            </a>
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:block" data-id="element-124" data-mp="xwgrvq3ichmr">
            <Button variant={isScrolled ? 'primary' : 'secondary'} className="py-2.5 px-5" onClick={openDemoMail} data-id="element-125" data-mp="xzl337fe4dmx">
              Book a Tour
            </Button>
          </div>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-zinc-400 hover:text-white" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-126" data-mp="a6mixjmb7d7s">
            {mobileMenuOpen ? <X size={24} data-id="element-127" data-mp="18sxx4tzw5zx" /> : <Menu size={24} data-id="element-128" data-mp="192g468st8v2" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden absolute top-full left-4 right-4 mt-2 glass-panel rounded-2xl p-6 flex flex-col gap-4" data-id="element-129" data-mp="68f815ej164i">
          {navLinks.map(link => <a key={link} href={`#${link.toLowerCase().replace(/\s+/g, '-')}`} className="text-lg font-medium text-zinc-300 hover:text-white py-2 border-b border-white/5" onClick={() => setMobileMenuOpen(false)} data-id="element-130" data-mp="20k3h4qy2uegz">
              {link}
            </a>)}
          <a href={TOURS_HASH} className="text-lg font-medium text-white py-2 border-b border-white/5" onClick={() => setMobileMenuOpen(false)} data-id="element-131" data-mp="2jiougml7459a">
            Virtual Tours
          </a>
          <Button variant="primary" className="mt-4 w-full" onClick={() => {
        setMobileMenuOpen(false);
        openDemoMail();
      }} data-id="element-132" data-mp="2oggmdglubrdh">
            Book a Tour
          </Button>
        </div>}
    </header>;
}